import { THEMES } from "../../utils/constants";

export default function ThemePicker({ value, onChange }) {
  return <div className="grid grid-cols-3 gap-2">{THEMES.map((theme) => <button key={theme} onClick={() => onChange(theme)} className={`tap rounded-app border border-white/10 p-3 capitalize ${value === theme ? "bg-violet-600" : "glass"}`}>{theme}</button>)}</div>;
}
